export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=701eacc0867a3d1c64dc7cc372d07f963a70e5e9b9&name=pushAdClickData!'